import { render, staticRenderFns } from "./TherapistInformationRow.vue?vue&type=template&id=06e167c3&scoped=true"
import script from "./TherapistInformationRow.vue?vue&type=script&lang=js"
export * from "./TherapistInformationRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e167c3",
  null
  
)

export default component.exports